import { Component, OnInit } from '@angular/core';
import { EmitterService } from 'src/app/shared/services/event-service';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ParameterConfig } from '../../shared/constant';
import { MinMaxService } from '../../shared/services/min-max.service';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-min-max',
  templateUrl: './min-max.component.html',
  styleUrls: ['./min-max.component.scss']
})
export class MinMaxComponent implements OnInit {

  public device_id: any;
  public date: String = '';
  public export_data: any = [];
  public data_param_el: String = '';
  public collective_devices: any = [];
  public location: String = 'N/A';
  public user: any;
  public curr_date: string = '';
  public fixed_interval: string = '6h';
  public intervalOptions = [
    { name: '6 hour', value: '6h' },
    { name: '12 hour', value: '12h' },
    { name: '18 hour', value: '18h' },
    { name: '24 hour', value: '24h' }
  ];

  public parametersList: ParameterConfig[] = [];
  public displayedParametersList: ParameterConfig[] = [];
  public selectedParameters: any[] = [];
  public dropdownSettings: IDropdownSettings = {};

  constructor(
    private authService: LoginService,
    private eventEmitter: EmitterService,
    private dataShared: DataSharedService,
    private minMaxService: MinMaxService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'params',
      textField: 'params',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.currentUser();
    this.eventEmitter.listen('getSelectedSingleDevice', (device_id) => {
      this.device_id = device_id
      this.resetSingleDevice()
      this.getMinMaxValue()
    });

    this.eventEmitter.listen('groupDevices', () => {
      this.collective_devices = [];
      this.dataShared.panel_devices.map(elem => this.collective_devices.push(elem.device_id));
    });

    this.getCurrDate()
  }

  resetSingleDevice() {
    this.date = '';
    this.getCurrDate();
  }

  getCurrDate() {
    let date = new Date();
    this.date = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    this.curr_date = String(date.getDate()).padStart(2, '0') + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + date.getFullYear();
  }

  currentUser() {
    this.authService.getUser().subscribe((res: any) => {
      if (res?.data || res?.user) {
        this.user = (res.data) ? res.data : res.user;
      }
    })
  }

  getMinMaxValue() {
    // Delegate to service
    this.minMaxService.getMinMaxData(this.device_id, this.date, this.fixed_interval).subscribe((result) => {
      this.parametersList = result;
      this.location = this.dataShared.device_detail.location;
      
      if (this.selectedParameters && this.selectedParameters.length > 0) {
        const selectedParamNames = this.selectedParameters.map(p => p.params);
        this.displayedParametersList = this.parametersList.filter(p => selectedParamNames.includes(p.params));
      }
    });
  }

  viewData() {
    if (!this.selectedParameters || this.selectedParameters.length === 0) {
      this.toastr.error('Please select at least one parameter to view', 'Error');
      this.displayedParametersList = [];
      return;
    }
    const selectedParamNames = this.selectedParameters.map(p => p.params);
    this.displayedParametersList = this.parametersList.filter(p => selectedParamNames.includes(p.params));
  }

  onDateSelection(e) {
    this.date = e.target.value
    this.getMinMaxValue()
  }

  onIntervalSelection(e) {
    this.fixed_interval = e.target.value;
    this.getMinMaxValue();
  }

  exportAsCSV() {
    let data = [];
    if (data = this.getDataByParam()) this.dataShared.exportDataAsCsvFormat(data);
  }

  getDataByParam() {
    return this.displayedParametersList;
  }

  exportAsPDF(e) {
    let data = [];
    if (data = this.getDataByParam()) this.dataShared.exportDataAsPdfFormat(data, e, this.data_param_el);
  }

}